<template>
  <div class="boxCanvas" v-show="showQrCode">
    <div class="canvasBg"></div>
    <div class="qrCodeBox">
      <div class="right">
        <img class="guanbi" @click="closeCode" src="@/assets/image/关闭.png" />
        <div class="title">账号注册</div>
        <div class="main">
          <el-form v-loading="logding" ref="formData" :model="formData" :rules="rules" label-width="80px"
            @submit.prevent="handleSubmit">
            <!-- 完善信息 -->
            <el-form-item label="真实姓名" prop="realName">
              <el-input v-model="formData.realName" placeholder="请输入真实姓名" />
            </el-form-item>
            <el-form-item label="身份证号" prop="idCardNo">
              <el-input v-model="formData.idCardNo" placeholder="请输入身份证号" />
            </el-form-item>
            <el-form-item label="手机号" prop="phoneNumber">
              <el-input v-model="formData.phoneNumber" placeholder="请输入手机号" />
            </el-form-item>

            <el-form-item label="头像" prop="certificateHeadPhoto">
              <div style="width: 80px; height: 80px" v-if="formData.certificateHeadPhoto">
                <img style="width: 80px; height: 80px" :src="formData.certificateHeadPhoto" />
              </div>
              <upload @handleUrl="handleUrl" />
            </el-form-item>
            <el-form-item label="工作单位" prop="schoolId">
              <span v-if="formData.schoolName" style="margin-right: 10px">{{
                formData.schoolName
                }}</span>
              <span v-if="formData.schoolId" style="
                  height: 21px;
                  line-height: 21px;
                  border: 1px solid #6b6b6b;
                  background-color: #ededed;
                  color: #000;
                  padding: 0 8px;
                  cursor: pointer;
                  display: inline-block;
                " @click="handleOrgList('修改单位', formData.schoolId)">修改单位</span>
              <span v-else style="
                  height: 21px;
                  border: 1px solid #6b6b6b;
                  background-color: #ededed;
                  padding: 0 8px;
                  color: #000;
                  cursor: pointer;
                " @click="handleOrgList('添加单位', undefined)">请选择单位</span>
            </el-form-item>
            <el-form-item label="所属专业" prop="majorCode">
              <span v-if="formData.majorCode" style="margin-right: 10px">{{
                getXw_XlName("zy", formData.majorCode)
                }}</span>
              <span v-if="formData.majorCode" style="
                  height: 21px;
                  line-height: 21px;
                  border: 1px solid #6b6b6b;
                  background-color: #ededed;
                  color: #000;
                  padding: 0 8px;
                  cursor: pointer;
                  display: inline-block;
                " @click="handleZYList('修改专业', formData.majorCode)">修改专业</span>
              <span v-else style="
                  height: 21px;
                  border: 1px solid #6b6b6b;
                  background-color: #ededed;
                  padding: 0 8px;
                  color: #000;
                  cursor: pointer;
                " @click="handleZYList('添加专业', undefined)">请选择专业</span>
            </el-form-item>
            <el-form-item label="登录密码" prop="password">
              <el-input type="password" v-model="formData.password" autocomplete="new-password" placeholder="请输入登录密码" />
            </el-form-item>
            <el-form-item label="确认密码" prop="newPassword">
              <el-input type="password" v-model="formData.newPassword" autocomplete="new-password"
                placeholder="请输入登录密码" />
            </el-form-item>
          </el-form>
        </div>
        <div @click="handleSubmit" v-loading="logding" class="jrwdkc2">
          注册并登录
        </div>
      </div>
    </div>
    <orgList ref="OrgList" :schoolId="formData.schoolId" @handleChage="handleSchoolChage"></orgList>
    <degreeList ref="degreeList" @handleChage="handleChage"></degreeList>
    <Verify @success="success" :mode="'pop'" :captchaType="'blockPuzzle'" :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"></Verify>
  </div>
</template>

<script>
import { register, getUserInfo, getMajorTree } from "@/api/user";
import upload from "@/components/upload.vue";
import OrgList from "@/components/orgList.vue";
import degreeList from "@/components/degreeList.vue";
import json_zy from "@/assets/json/json_zy";
import JSEncrypt from "jsencrypt";
import Verify from "@/components/verifition/Verify.vue";
const encryptor = new JSEncrypt();
export default {
  components: {
    upload,
    OrgList,
    degreeList,
    Verify,
  },
  data() {
    return {
      json_zy,
      showQrCode: false,
      imageCode: "",
      formData: {
        realName: undefined,
        idCardNo: undefined,
        phoneNumber: undefined,
        certificateHeadPhoto: undefined,
        loginName: undefined,
        password: undefined,
        newPassword: undefined,
        schoolId: undefined,
        majorCode: undefined,
      },
      rules: {
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        idCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        phoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        certificateHeadPhoto: [
          { required: true, message: "请上传头像", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
        ],
        schoolId: [{ required: true, message: "请选择单位", trigger: "blur" }],
        majorCode: [{ required: true, message: "请选择专业", trigger: "blur" }],
      },
      logding: false,
      majorTreeList: [],
      publicKey: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvHdaUj121trhuXVQNTuweOAQIIGk1DOMIsN2Wt4F0B9mLtDJslW6dWVz8A4u3mZ6Jhu4SizXXWq63mD6Xaq/yUC8NkH3GBS8XCClQqZ6eIJR8zKBNkrpRQMgo0apiRThoksGnd/1AE+vrgZZZ9g/1bhyn2KJ2bY6qZJGb56XyKFBv7zciZ6q/S3KJruClk5FccwFwtQbsegkAyZOm+3wXW/Z2gxywVZvdbh+12abkFusRI0EdwFJspC7gYakG9Ml1iPW4kYLr2hXK2RrTGOUAo7VwI/QkNkJqaybb/A5G1vuvNqZjpOSWZhCBcM2Iheo6NSk00MX1upwAHB6e8hpRQIDAQAB`,
    };
  },
  mounted() {
    this.getMajorTree();
  },
  methods: {
    showModal() {
      this.showQrCode = true;
    },
    handleZYList(title, code) {
      this.$refs.degreeList.show("zy", title, code);
    },
    getXw_XlName(type, code) {
      let name = "";
      if (type == "zy") {
        this.json_zy.forEach((item) => {
          console.log(code);
          console.log(item.code);
          if (item.code == code) {
            name = item.value;
          }
          if (item.sub.length > 0) {
            item.sub.forEach((itemm) => {
              console.log(code);
              console.log(itemm.code);
              if (itemm.code == code) {
                name = itemm.value;
              }
              if (itemm.sub.length > 0) {
                itemm.sub.forEach((itemmm) => {
                  console.log(code);
                  console.log(itemmm.code);
                  if (itemmm.code == code) {
                    name = itemmm.value;
                  }
                });
              }
            });
          }
        });
      }
      return name;
    },
    handleChage(item) {
      if (item.type == "zy") {
        this.formData.majorCode = item.code;
      }
      this.$forceUpdate();
    },
    handleSchoolChage(item) {
      this.formData.schoolId = item.orgId;
      this.formData.schoolName = item.orgName;
    },
    handleOrgList(title, schoolId) {
      this.$refs.OrgList.show(title, schoolId);
    },
    getMajorTree() {
      getMajorTree().then((res) => {
        this.majorTreeList = res.result[0].children;
        this.recursionList(this.majorTreeList);
      });
    },

    // 递归数据list chileren 如果是空数组转成null
    recursionList(list) {
      for (let item of list) {
        item.children = null;
        // if (item.children && item.children.length === 0) {
        //   item.children = null;
        // } else if (item.children && item.children.length > 0) {
        //   this.recursionList(item.children);
        // }
      }
    },
    handleUrl(url) {
      this.formData.certificateHeadPhoto = url;
    },

    async success(captchaData) {
      // 使用jsencrypt库进行加密
      encryptor.setPublicKey(this.publicKey);
      try {
        let regData = {
          captchaCode: this.formData.captchaCode,
          captchaId: this.formData.captchaId,
          realName: this.formData.realName,
          idCardNo: encryptor.encrypt(this.formData.idCardNo),
          password: encryptor.encrypt(this.formData.password),
          phoneNumber: this.formData.phoneNumber,
          certificateHeadPhoto: this.formData.certificateHeadPhoto,
          majorCode: this.formData.majorCode,
          schoolId: this.formData.schoolId,
        };
        const regRes = await register({
          ...regData,
          captchaData: captchaData,
        });
        if (regRes.code == 200 && regRes.data) {
          localStorage.setItem("userInfo", JSON.stringify(regRes.data));
          localStorage.setItem("token", regRes.data.userToken);

          const user = await getUserInfo();
          localStorage.setItem("firstLogin", true);
          if (user.data) {
            if (window.location.href.indexOf("sa.tiehouedu.com") > -1) {
              window.location.href = window.origin + "/xzzj/pc/#/";
            } else if (window.location.href.indexOf("xzzhuanji.cn/migrate") > -1) {
              window.location.href = window.origin + "/migrate/pc/#/";
            } else {
              window.location.href = window.origin + "/#/";
            }
          }
        } else {
          this.$message.warning(regRes.msg);
        }
      } catch (error) {
        this.logding = false;
      }
    },
    // 提交注册
    async handleSubmit() {
      if (this.formData.password != this.formData.newPassword) {
        return this.$message.warning("密码不一致, 请重新输入");
      }
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          if (!this.formData.certificateHeadPhoto) {
            return this.$message.warning("请上传头像");
          }
          this.$refs.verify.show();
        } else {
          return false;
        }
      });
    },
    closeCode() {
      this.showQrCode = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.boxCanvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 102;

  .canvasBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .qrCodeBox {
    position: absolute;
    background: #fff;
    width: 500px;
    max-height: 80vh;
    padding-bottom: 20px;
    border-radius: 10px;
    overflow: hidden;
    overflow-y: scroll;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

    .left {
      padding: 20px;
      width: 300px;
      height: 100%;
      background: #f7f7f7;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      font-size: 20px;

      .logo {
        width: 100%;
        margin-bottom: 50px;
      }
    }

    .right {
      width: 500px;
      padding: 20px;
      padding-top: 30px;
      box-sizing: border-box;

      .title {
        text-align: center;
        font-size: 22px;
        margin-bottom: 10px;
      }

      .main {
        border-top: 1px solid #dcdfe6;
        padding: 20px;
        box-sizing: border-box;
        margin-bottom: 10px;
      }

      .button {
        width: 100%;
        margin: 0 auto;
        color: #fff;
      }
    }
  }
}

.right {
  width: 500px;
  box-sizing: border-box;

  .title {
    text-align: center;
    font-size: 22px;
    margin-bottom: 10px;
  }

  .main {
    border-top: 1px solid #dcdfe6;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }
}

.jrwdkc2 {
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background: linear-gradient(180deg, #41a0f1 0%, #0a5b9f 100%) !important;
  font-size: 14px;
  color: #ffffff;
  border-radius: 10px;
  cursor: pointer;
}
</style>
